import React from 'react';
import { Route, Routes } from 'react-router-dom';
import SPAPageHeader from '../shared/SPAPageHeader';
import SPANotFound from '../shared/SPANotFound';
import AssignmentDetail from './AssignmentDetail';
import LineItemPicker from './LineItemPicker';
import MasqueradeNotice from './MasqueradeNotice';
import CourseRoster from './CourseRoster';
import AssigneePicker from './AssigneePicker';
import StudentLinks from './StudentLinks';
import StudentHistory from './StudentHistory';
import SyncLog from './SyncLog';
import GradeSyncTabs from './GradeSyncTabs';
import PlatformHealthTab from './PlatformHealthTab';
import TroubleshootTab from './TroubleshootTab';
import RateLimitsTab from './RateLimitsTab';
import TeacherView from './TeacherView';
import TeachersTab from './TeachersTab';
import { useGradeSyncPath } from './gradeSyncPath';

const GradeSyncShell = ({ children }: { children: React.ReactNode }) => (
  <div className="tw-min-h-screen tw-bg-spa-bg tw-text-spa-on-bg">
    <div className="tw-mx-auto tw-max-w-[1400px] tw-px-6 tw-py-4">
      <SPAPageHeader title="Grade Sync Health" />
      <GradeSyncTabs />
      <p className="tw-mb-5 tw-mt-0 tw-text-sm tw-text-spa-secondary">
        Whether current scores are actually in the LMS — Canvas, Schoology, Google Classroom.
      </p>
      {children}
    </div>
  </div>
);

const GradeSyncNotFound = () => {
  const gradeSyncPath = useGradeSyncPath();

  return <SPANotFound homeLabel="Back to grade sync" homeTo={gradeSyncPath()} />;
};

const GradeSyncView = () => (
  <>
    <MasqueradeNotice />
    <Routes>
      <Route element={<GradeSyncShell><TeachersTab /></GradeSyncShell>} path="/" />
      <Route element={<GradeSyncShell><TroubleshootTab /></GradeSyncShell>} path="troubleshoot" />
      <Route element={<GradeSyncShell><PlatformHealthTab /></GradeSyncShell>} path="platform" />
      <Route element={<GradeSyncShell><RateLimitsTab /></GradeSyncShell>} path="rate-limits" />
      <Route element={<TeacherView />} path="teachers/:id" />
      <Route element={<AssignmentDetail />} path="assignments/:id">
        <Route element={<LineItemPicker />} path="columns" />
        <Route element={<LineItemPicker />} path="copies/:copyId/columns" />
        <Route element={<CourseRoster />} path="courses/:courseId" />
        <Route element={<AssigneePicker />} path="assignees" />
        <Route element={<StudentLinks />} path="students" />
        <Route element={<SyncLog />} path="log" />
        <Route element={<StudentHistory />} path="history/:studentId" />
      </Route>
      <Route element={<GradeSyncNotFound />} path="*" />
    </Routes>
  </>
);

export default GradeSyncView;
